// @ts-nocheck
import React from "react";
import styled from "styled-components";
import { DownloadOutlined, CloseOutlined } from "@ant-design/icons";
import { Menu, Dropdown, Button, Tooltip } from "antd";
import { getFileExtension, isEmpty } from "../../../libs/utilities";
import classNames from "classnames";
import { mustBeArray } from "../../../libs";
import { FileTypeIcon } from "../../../Common/ui";
import { useAnalyticsEventTracker } from "../../../hooks";
import {
  DOWNLOAD_PAYRUN_PDF_BUTTON,
  DELETE_PAYRUN_FILE_BUTTON,
} from "../../../constants";
import { AuthorisationModule } from "@xemplo/role-types";
import { RoleRenderer } from "@xemplo/role-renderer";

const commonIconClasses = "text-xs ml-2";

const AntMenuItem = styled(Menu.Item)`
  white-space: normal !important;
  word-wrap: "break-word" !important;
`;

const OutlinedClosed = styled(CloseOutlined)`
  position: absolute !important;
  right: 1px !important;
  margin-top: 5px;
`;

const PayrunDownloadOptions = ({
  classname,
  disabled,
  payrunReports,
  handleReportDownload,
  handleDeletePayrunFile,
  title,
}: any) => {
  const [exportABALoading, setExportABALoading] = React.useState(false);

  const gaEventTracker = useAnalyticsEventTracker("Pay Run Download");

  const onClickDownloadOption = (option: any) => {
    let extensionType = getFileExtension(option.originalFileName);
    const fileName = `${option.displayName}.${extensionType}`;
    handleReportDownload({ id: option.id, fileName: fileName });
    gaEventTracker(`Report Downloaded`, `Report downloaded`);
  };

  const onClickDelete = (option, event) => {
    const extensionType = getFileExtension(option.originalFileName);
    const fileName = `${option.displayName}.${extensionType}`;
    handleDeletePayrunFile({
      payrunId: option.payRunId,
      id: option.id,
      fileName,
    });
    event.preventDefault();
    event.stopPropagation();
  };

  const dropdownClassnames = classNames(
    "btn-dropdown",
    classname,
    {
      "Visible-Disabled": disabled && isEmpty(mustBeArray(payrunReports)),
    },
    {
      "btn-dropdown-success": !disabled || !isEmpty(mustBeArray(payrunReports)),
    }
  );

  const downloadButtonClassnames = classNames(
    "rounded-lg",
    {
      "Visible-Disabled bg-disabled":
        disabled && isEmpty(mustBeArray(payrunReports)),
    },
    {
      "bg-success": !disabled || !isEmpty(mustBeArray(payrunReports)),
    }
  );

  const menu = (
    <Menu className="user-authentication">
      {/** Loop through payrunReports (all payrun files) and render menu option for each one */}
      {mustBeArray(payrunReports).map((option: any, i: any) => {
        return (
          <AntMenuItem
            key={option.id}
            onClick={() => onClickDownloadOption(option)}
          >
            <DownloadOutlined /> {option.displayName}
            <FileTypeIcon
              className={commonIconClasses}
              type={getFileExtension(option.originalFileName)}
            />
            <RoleRenderer
              module={AuthorisationModule.payrun}
              component={DELETE_PAYRUN_FILE_BUTTON}
            >
              <span>
                <OutlinedClosed onClick={(e) => onClickDelete(option, e)} />
              </span>
            </RoleRenderer>
          </AntMenuItem>
        );
      })}
    </Menu>
  );

  return (
    <RoleRenderer
      module={AuthorisationModule.payrun}
      component={DOWNLOAD_PAYRUN_PDF_BUTTON}
    >
      <Tooltip title={title ?? ""}>
        <Dropdown
          className={dropdownClassnames}
          trigger={["click"]}
          overlay={menu}
        >
          <Button
            disabled={disabled && isEmpty(mustBeArray(payrunReports))}
            className={downloadButtonClassnames}
          >
            Download
          </Button>
        </Dropdown>
      </Tooltip>
    </RoleRenderer>
  );
};

export default PayrunDownloadOptions;
